import React from "react";
import { Modal, Text } from "@mantine/core";
import { ReactComponent as SuccessIcon } from "../../../../common/assets/green-checkmark.svg";
import { useStyles } from "../blocked-dates/BlockedDatesAppliedSuccessfully";

type Props = {
  openedConfirmationBlockedDatesModal: boolean;
  setOpenedConfirmationBlockedDatesModal: (val: boolean) => void;
};
const ConfirmationBlockedDatesModal: React.FC<Props> = ({
  openedConfirmationBlockedDatesModal,
  setOpenedConfirmationBlockedDatesModal,
}) => {
  const { classes } = useStyles();

  return (
    <Modal
      className={classes[".mantine-Modal-header "]}
      size="lg"
      centered
      opened={openedConfirmationBlockedDatesModal}
      onClose={() => {
        setOpenedConfirmationBlockedDatesModal(false);
        window.location.reload();
      }}
      closeOnClickOutside
      styles={{
        header: {
          backgroundColor: "#ffffff",
          padding: "40px 40px 0 0",
        },
        body: {
          paddingTop: "0",
        },
        close: {
          borderColor: "white",
        },
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          width: "400px",
          margin: "30px auto",
        }}
      >
        <SuccessIcon />
        <Text
          size="xl"
          style={{
            marginTop: "30px",
            fontSize: "18px",
            fontWeight: 700,
            lineHeight: "24.59px",
          }}
        >
          Blocked Dates Successfully Deleted!
        </Text>
        <Text size="xs" weight={400} mt={12}>
          The blocked dates you had set have been deleted and will be no longer
          be available to your employees.
        </Text>
      </div>
    </Modal>
  );
};

export default ConfirmationBlockedDatesModal;
